import createReactComponent from '../createReactComponent';
export default createReactComponent('chart-no-axes-gantt', 'ChartNoAxesGantt', [["path",{"d":"M5 14h11m-7-4h11M7 18h11M6 6h11","key":"svg-0"}]]);